import { useMemo } from 'react';
import { useFetch } from '@moko/ui';
import {
  getPricingParameterDefinitions,
  type IPricingParameterDefinition,
} from '../../services/pricingParameterService';
import {
  getPricingItems,
  type IPricingItem,
} from '../../services/pricingService';

export interface PricingParameterCatalog {
  definitions: IPricingParameterDefinition[];
  pricingItems: IPricingItem[];
  error: Error | null;
  ready: boolean;
}

export const usePricingParameterCatalog = (): PricingParameterCatalog => {
  const definitionsFetch = useFetch<IPricingParameterDefinition[]>({
    queryKey: ['pricingParameterDefinitions'],
    queryFn: getPricingParameterDefinitions,
  });
  const itemsFetch = useFetch<IPricingItem[]>({
    queryKey: ['pricingItems'],
    queryFn: async (abortController) =>
      [...(await getPricingItems(abortController, 500, 1)).items].sort(
        (a, b) => a.sortOrder - b.sortOrder
      ),
  });

  return useMemo(
    () => ({
      definitions: definitionsFetch.data ?? [],
      pricingItems: itemsFetch.data ?? [],
      error: definitionsFetch.error ?? itemsFetch.error,
      ready: !!definitionsFetch.data && !!itemsFetch.data,
    }),
    [
      definitionsFetch.data,
      definitionsFetch.error,
      itemsFetch.data,
      itemsFetch.error,
    ]
  );
};
